import React, { PropTypes } from "react";
 import swal from 'sweetalert2'
const propTypes = {
    baseColor: PropTypes.string,
    activeColor: PropTypes.string,
    overlayColor: PropTypes.string
};
 
const defaultProps = {
    baseColor: 'gray',
    activeColor: 'green',
    overlayColor: 'rgba(255,255,255,0.3)'
};
 
class FileUploader extends React.Component {
    constructor(props) {
        super(props);
         
        this.state = {
            active: false,
            imageSrc: '',
            loaded: false,
            cambio:false,
        }         
        this.onDragEnter  = this.onDragEnter.bind(this);
        this.onDragLeave  = this.onDragLeave.bind(this);
        this.onDrop       = this.onDrop.bind(this);
        this.onFileChange = this.onFileChange.bind(this);
        this.cambio = this.cambio.bind(this);
    }
     componentWillReceiveProps(nextProps)
    { 
        // if(this.props.url!=null)
        // {
           
        //    this.setState({ imageSrc: this.props.url });
        // }
         
        
    }
    cambio() {
       return this.state.cambio;
    }
     
    onDragEnter(e) {
        this.setState({ active: true });
    }
     
    onDragLeave(e) {
        this.setState({ active: false });
    }
     
    onDragOver(e) { 
        e.preventDefault(); 
    }
     
    onDrop(e) {
        e.preventDefault();
        this.setState({ active: false });
        this.onFileChange(e, e.dataTransfer.files[0]);
    }
     
    onFileChange(e, file) {
        switch(this.props.extension){
            case "cer":
                var pattern = /^\w+(.cer)$/i;
                break;
            case "key":
                var pattern = /^\w+(.key)$/i;
                break;
            case "xml":
                var pattern = /^\w+(.xml)$/i;
                break;

        }

        var file = file || e.target.files[0],
            reader = new FileReader();
            console.log("archivo--->",file.name);
             
        if (!file.name.match(pattern)) {
             swal("Oops..", "Formato inválido");
            return;
        }
         
        this.setState({ loaded: false, cambio:true });
         
        reader.onload = (e) => {
            this.setState({ 
                imageSrc: reader.result, 
                loaded: true
            }); 
        }
         
        reader.readAsDataURL(file);
    }
     
    getFileObject() {
        
        return this.refs.input.files[0];
    }
     
    getFileString() {
        return this.state.imageSrc;
    }
     
    render() {
        let state = this.state,
            props = this.props,
            labelClass  = `uploader ${state.loaded && 'loaded'}`,
            borderColor = state.active ? props.activeColor : props.baseColor,
            iconColor   = state.active 
                ? props.activeColor
                : (state.loaded) 
                    ? props.overlayColor 
                    : props.baseColor;
         
        return (
            <label 
                className={labelClass}
                onDragEnter={this.onDragEnter}
                onDragLeave={this.onDragLeave} 
                onDragOver={this.onDragOver}
                onDrop={this.onDrop}
                style={{outlineColor: borderColor}}>
                <i className="icon icon-upload"
                    style={{ color: iconColor }}></i>
                <input type="file"   onChange={this.onFileChange} ref="input" />
               
                
                
            </label>
        );
    }
}
 
FileUploader.propTypes = propTypes;
FileUploader.defaultProps = defaultProps;
 
export default FileUploader;


// WEBPACK FOOTER //
// ./src/components/datosfactura/fileuploader.js